import { render, staticRenderFns } from "./MultiLanguageEditDialog.vue?vue&type=template&id=56edc550&scoped=true&"
import script from "./MultiLanguageEditDialog.vue?vue&type=script&lang=js&"
export * from "./MultiLanguageEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./MultiLanguageEditDialog.vue?vue&type=style&index=0&id=56edc550&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56edc550",
  null
  
)

export default component.exports